import React from 'react';
import styled from 'styled-components';

interface PeriodToggleProps {
  options: { label: string; value: string }[];
  value: string;
  onChange: (value: string) => void;
}

export const PeriodToggle: React.FC<PeriodToggleProps> = ({
  options,
  value,
  onChange
}) => {
  return (
    <Wrap>
      {options.map((opt) => (
        <ToggleBtn
          key={opt.value}
          $active={opt.value === value}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </ToggleBtn>
      ))}
    </Wrap>
  );
};

const Wrap = styled.div`
  display: flex;
  background: var(--paper);
  border-radius: 7px;
  padding: 2px;
  gap: 2px;
`;

const ToggleBtn = styled.button<{ $active: boolean }>`
  background: ${({ $active }) => ($active ? 'var(--white)' : 'none')};
  border: none;
  padding: 6px 14px;
  font-family: var(--font-sans);
  font-size: 12.5px;
  font-weight: 500;
  color: ${({ $active }) => ($active ? 'var(--ink)' : 'var(--ink-muted)')};
  border-radius: 5px;
  cursor: pointer;
  box-shadow: ${({ $active }) => ($active ? 'var(--shadow-sm)' : 'none')};
  transition: all 0.15s;

  &:hover {
    color: var(--ink);
  }
`;
